import { render } from "./commonParts.vue?vue&type=template&id=c02f2054"
import script from "./commonParts.vue?vue&type=script&lang=js"
export * from "./commonParts.vue?vue&type=script&lang=js"

import "./commonParts.vue?vue&type=style&index=0&id=c02f2054&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__